module.exports = __webpack_public_path__ + "69014054cb31a9da8c802c352a601c9d.svg";